import PropTypes from 'prop-types';

import Title from './Title';
import Description from './Description';
import Svg503 from 'assets/svg/503.svg';

export default function _503({ title, description }) {
  return (
    <>
      <img src={Svg503} style={{ height: '40%' }} />
      {title && <Title>{title}</Title>}
      {description && <Description>{description}</Description>}
    </>
  );
}

_503.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string
};
